import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const BLANK = "__blank__";

export default function CategoryPicker({ value, onChange, categories, testId, className = "" }) {
  const options = (categories || []).filter((c) => c.active || c.id === value);
  return (
    <Select value={value || BLANK} onValueChange={(v) => onChange(v === BLANK ? null : v)}>
      <SelectTrigger data-testid={testId}
        className={`h-8 text-xs ${value ? "" : "border-amber-500/50 bg-amber-500/10 text-amber-200"} ${className}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={BLANK}>— Blank —</SelectItem>
        {options.map((c) => (
          <SelectItem key={c.id} value={c.id}>
            {c.name} <span className="text-muted-foreground text-[10px] uppercase ml-1">{c.type}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
